/**
 * Airwallex Configuration
 *
 * Contains configuration values for Airwallex integration
 * Values are loaded from environment variables
 */

export const AIRWALLEX_CONFIG = {
  // Airwallex OAuth Client ID (from POC backend)
  // This is the OAuth application ID registered in Airwallex Dashboard
  // NOT the account ID (which starts with "acct_")
  CLIENT_ID: process.env.REACT_APP_AIRWALLEX_CLIENT_ID,

  // Environment: "demo" for testing, "prod" for production
  ENV: process.env.REACT_APP_AIRWALLEX_ENV,

  // Demo account email (for testing)
  DEMO_ACCOUNT_EMAIL: process.env.REACT_APP_AIRWALLEX_DEMO_ACCOUNT_EMAIL,

  // Airwallex URLs
  DEMO_URL: process.env.REACT_APP_AIRWALLEX_DEMO_URL,
  HELP_URL: process.env.REACT_APP_AIRWALLEX_HELP_URL,

  // Minimum balance threshold (in USD) required to complete wallet setup
  // When total balance (sum of all usd_total_amount) is below this threshold,
  // users will be prompted to add funds in step 3 of onboarding
  MIN_BALANCE_THRESHOLD: 100,
};
